import {
  doGETRequest,
  doPOSTRequest,
} from "./Api";

const BASE_URL = "/pending-product-item";

export default class ProductApprovalApi {

  static async listPending() {
    try {
      const response = await doGETRequest(BASE_URL);
      return { success: true, data: response.data };
    } catch (err) {
      console.error(err);
      return { success: false, data: [] };
    }
  }

  static async listPendingPaged(search: string = "", page: number = 0, size: number = 50) {
    try {
      const qs = new URLSearchParams({ search: search || "", page: String(page), size: String(size) });
      const response = await doGETRequest(`${BASE_URL}/paged?${qs.toString()}`);
      return { success: true, data: response.data };
    } catch (err) {
      console.error(err);
      return { success: false, data: null };
    }
  }

  static async getPendingById(id: number) {
    try {
      const response = await doGETRequest(`${BASE_URL}/${id}`);
      return { success: true, data: response.data[0] }; // id ile tek ürün geliyor
    } catch (err) {
      console.error(err);
      return { success: false, data: null };
    }
  }

  static async createProduct(dto: any) {
    try {
      const response = await doPOSTRequest(BASE_URL, dto);
      return { success: true, data: response.data };
    } catch (err) {
      console.error(err);
      return { success: false };
    }
  }

  public static async listPackagingGroups() {
     const relativePath = "/product-item/packagingGroups";
     var response = await doGETRequest(relativePath);
     return response;
   }

   public static async listWarehouseStockTypes() {
       const relativePath = "/product-item/warehouseStockType";
       var response = await doGETRequest(relativePath);
       return response;
    }

}
